// extracted by mini-css-extract-plugin
export default {"radio":"_37DeRUTm"};